import React from "react"
import { useProvincesLazyQuery } from "../../../api/backend/backend-api"

export const useProvinces = (countryCode: string) => {
  const [getProvinces, result] = useProvincesLazyQuery()

  React.useEffect(() => {
    if (countryCode) {
      getProvinces({
        variables: {
          countryCode,
        },
      })
    }
  }, [countryCode])

  return result
}
